export const SettingsStatusTone = {
  Fail: 'fail',
  InProgress: 'inProgress',
  Neutral: 'neutral',
  Ok: 'ok',
}
